<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/DNPgbA/tc-custom/9781250033918.jpg?1731184709307" alt="This image is the cover for the book Close My Eyes"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Close My Eyes
      </h1>
      <p class="bookDescription body article font2">
        <b>“<i>Gone Girl</i> meets <i>Before I Go to Sleep</i>” when a grieving mother learns that her daughter may still be alive in this “riveting psychological thriller” (Bookreporter). </b><br/><br/>When Geniver Loxley lost her daughter at birth eight years ago, her world stopped . . . and never fully started again. Mothers with strollers still make her flinch; her love of writing has turned into a half-hearted teaching career; and she and her husband, Art, have slipped into the kind of rut that seems inescapable.<br/><br/>But then a stranger shows up on their doorstep, telling Gen the very thing she’s always wanted to hear: that her daughter Beth was not stillborn, but was taken away as a healthy infant and is still out there . . . somewhere. It’s unbelievable. But why would anyone make that up? Gen is suddenly consumed by a flood of unanswerable questions. Where is Beth now? Why is Art so reluctant to get involved? And who can she trust to help her find answers?<br/><br/>Gen delves into the dark corners of her past on a desperate search for clues. But hope quickly turns into fear and paranoia, as she realizes that finding the answers might open the door to something even worse than not knowing. A truth that could steal everything she holds close—even her own life.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sophie McKenzie
      </h2>
      
      <p class="authorDescription body article"><P>SOPHIE MCKENZIE is also the bestselling author of more than fifteen novels for children and teens in the UK, including the award winning <I>Girl, Missing</I> and <I>Blood Ties</I>. She has won numerous awards, was one of the first Richard and Judy children's book club winners, and has twice been longlisted for the prestigious Carnegie Medal. She lives in London and writes full-time.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6988b3e1